var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90573 0.300097L0.305725 2.9001C-0.0109418 3.21676 -0.0816084 3.5791 0.093725 3.9871C0.269058 4.3951 0.581392 4.59943 1.03073 4.6001H6.18072C6.63072 4.6001 6.94339 4.39576 7.11872 3.9871C7.29406 3.57843 7.22306 3.2161 6.90573 2.9001L4.30572 0.300097C4.20572 0.200098 4.09739 0.125098 3.98073 0.075098C3.86406 0.0250978 3.73906 9.72748e-05 3.60573 9.72748e-05C3.47239 9.72748e-05 3.34739 0.0250978 3.23073 0.075098C3.11406 0.125098 3.00573 0.200098 2.90573 0.300097Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.3c9c7b1d19c7d909ebf86bb76bae7c2c.svg";
export { ForwardRef as ReactComponent };